<template>
  <custom-dialog class="part-send-order-dialog" width="1000px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" ref="print">
      <div class="hide-title">
        {{ model.title }}
      </div>
      <div class="part-send-order-dialog-title">
        {{ $t('crm_part_send_order_dialog.ling_jian_fa_huo_dan') }}
      </div>
      <div class="order-list">
        <table border="1" style="border-collapse: collapse" class="table">
          <tr>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.shou_huo_gong_si') }}</th>
            <th colspan="15" :style="getColspanWidth(15)">{{ info.consigneeOrgName || '-' }}</th>
          </tr>
          <tr>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.shou_huo_ren') }}</th>
            <th colspan="5" :style="getColspanWidth(5)">{{ info.consigneeName || '-' }}</th>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.shou_huo_dian_hua') }}</th>
            <th colspan="5" :style="getColspanWidth(5)">{{ info.consigneePhone || '-' }}</th>
          </tr>
          <tr>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.shou_huo_di_zhi') }}</th>
            <th colspan="15" :style="getColspanWidth(15)">{{ info.consigneeAddress || '-' }}</th>
          </tr>

          <tr>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.wu_liu_gong_si') }}</th>
            <th colspan="5" :style="getColspanWidth(5)">{{ info.logisticsCompanyName || '-' }}</th>
            <th colspan="2" :style="getColspanWidth(2)">{{ $t('Common.com_remark') }}</th>
            <th colspan="8" :style="getColspanWidth(8)"></th>
          </tr>

          <tr>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.ling_jian_bian_hao') }}</th>
            <th colspan="2" :style="getColspanWidth(2)">{{ $t('crm_part_send_order_dialog.shu_liang') }}</th>
            <th colspan="3" :style="getColspanWidth(3)">{{ $t('crm_part_send_order_dialog.di_kou_shu_liang') }}</th>
            <th v-if="!isFinish" colspan="2" :style="getColspanWidth(2)">{{ $t('crm_part_send_order_dialog.dai_fa_huo') }}</th>
            <th v-if="isFinish" colspan="2" :style="getColspanWidth(2)">{{ $t('crm_part_send_order_dialog.yi_fa_huo') }}</th>
            <th colspan="3" :style="getColspanWidth(3)">{{ $t('crm_part_send_order_dialog.he_tong_bian_hao') }}</th>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.ji_shen_hao') }}</th>
          </tr>

          <tr v-for="(pItem, index) in info.giveawayList" :key="index">
            <th colspan="5" :style="getColspanWidth(5)">{{ pItem.codeName || '-' }}</th>
            <th colspan="2" :style="getColspanWidth(2)">{{ pItem.bookingNum === undefined ? '-' : pItem.bookingNum }}</th>
            <th colspan="3" :style="getColspanWidth(3)">{{ pItem.useStockNum === undefined ? '-' : pItem.useStockNum }}</th>
            <th v-if="!isFinish" colspan="2" :style="getColspanWidth(2)">{{ pItem.waitShipNum === undefined ? '-' : pItem.waitShipNum }}</th>
            <th v-if="isFinish" colspan="2" :style="getColspanWidth(2)">{{ (pItem.bookingNum || 0) - (pItem.useStockNum || 0) }}</th>
            <th colspan="3" :style="getColspanWidth(3)">{{ pItem.contractNo || '-' }}</th>
            <th colspan="5" :style="getColspanWidth(5)">{{ pItem.bodyNum || '-' }}</th>
          </tr>
          <tr>
            <th colspan="5" :style="getColspanWidth(5)">{{ $t('crm_part_send_order_dialog.he_ji') }}</th>
            <th colspan="2" :style="getColspanWidth(2)">{{ bookingNumTotal }}</th>
            <th colspan="3" :style="getColspanWidth(3)">{{ useStockNumTotal }}</th>
            <th colspan="2" :style="getColspanWidth(2)">{{ !isFinish ? waitShipNumTotal : hasShipNumTotal }}</th>
            <th colspan="3" :style="getColspanWidth(3)"></th>
            <th colspan="5" :style="getColspanWidth(5)"></th>
          </tr>
        </table>
      </div>
      <div class="finish-time" v-if="isFinish">{{ $t('crm_part_send_order_dialog.wan_cheng_ri_qi') }}：{{ $momentLocal(info.shipperTime, 'YYYY-MM-DD') }}</div>
    </div>
    <div slot="footer" class="dialog-footer" v-if="!isFinish">
      <el-button type="danger" size="small" v-if="funcView.free_accessories_order_delete" @click="deleteSend">{{ $t('crm_part_send_order_dialog.shan_chu_fa_huo_dan') }}</el-button>
      <el-button size="small" @click="confirmSend">{{ $t('crm_part_send_order_dialog.que_ren_fa_huo') }}</el-button>
      <el-button type="primary" size="small" @click="onPrint">{{ $t('crm_part_send_order_dialog.da_yin_fa_huo_dan') }}</el-button>
    </div>
    <div slot="footer" class="dialog-footer" v-if="isFinish">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/**
 *
 */
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import moment from 'moment';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    // 是否是已完成状态
    isFinish: { type: Boolean, default: false },
  },
  data() {
    return {
      dataList: [],
      isLoading: false,
      item: {
        goodsList: [],
      },
      // deviceList: [],
      info: {
        giveawayList: [],
      },
    };
  },
  computed: {
    now() {
      return moment().format('YYYY-MM-DD');
    },
    bookingNumTotal() {
      const list = this.info.giveawayList;
      if (list && list.length) {
        return list.reduce((preVal, item) => {
          const num = item.bookingNum || 0;
          return num + preVal;
        }, 0);
      }

      return 0;
    },
    useStockNumTotal() {
      const list = this.info.giveawayList;
      if (list && list.length) {
        return list.reduce((preVal, item) => {
          const num = item.useStockNum || 0;
          return num + preVal;
        }, 0);
      }

      return 0;
    },
    waitShipNumTotal() {
      const list = this.info.giveawayList;
      if (list && list.length) {
        return list.reduce((preVal, item) => {
          const num = item.waitShipNum || 0;
          return num + preVal;
        }, 0);
      }

      return 0;
    },

    // 已发货总数
    hasShipNumTotal() {
      const bookingNumTotal = this.bookingNumTotal || 0;
      const useStockNumTotal = this.useStockNumTotal || 0;

      return bookingNumTotal - useStockNumTotal;
    },
    // bookingNumTotal() {
    //   return this.deviceList.reduce((total, item) => total + Number(item['bookingNum'] || 0), 0);
    // },
    // hqNeedShipNumTotal() {
    //   return this.deviceList.reduce((total, item) => total + Number(item['hqNeedShipNum'] || 0), 0);
    // },
  },

  methods: {
    deleteSend() {
      this.$showConfirm(this.$t('crm_part_send_order_dialog.sfqrscfhd')).then(() => {
        this.$postJSON(apis.giveawayDelete, { deliveryBatchNum: this.model.data.deliveryBatchNum }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        });
      });
    },
    confirmSend() {
      this.$showConfirm(this.$t('crm_part_send_order_dialog.sfqrfh')).then(() => {
        const reqUrl = `${apis.giveawayFinishBatch}/${this.info.deliveryBatchNum}`;
        this.$postJSON(reqUrl).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        });
      });
    },
    onPrint() {
      this.$print(this.$refs.print);
    },
    getColspanWidth(num) {
      return `width:${num * 5}%;`;
    },
    getOrderClass(item) {
      // 订单类型，transfer-调拨 lease-租赁 order-销售 trial-试用
      let orderClass = '';
      const bizClass = item.contractType;
      if (['10', '20', '30'].includes(`${bizClass}`)) {
        orderClass = 'lease';
      } else if (['40'].includes(`${bizClass}`)) {
        orderClass = 'sale';
      } else if (['50'].includes(`${bizClass}`)) {
        orderClass = 'order';
      } else if (['90'].includes(`${bizClass}`)) {
        orderClass = 'transfer';
      } else if (['10'].includes(`${bizClass}`)) {
        orderClass = 'trial';
      }
      return orderClass;
    },
    getPageInfo() {
      this.$getJSON(apis.giveawayShipDetail, {
        deliveryBatchNum: this.model.data.deliveryBatchNum,
      }).then((res) => {
        const data = res.data;

        this.info = data;
      });
    },
    // 保存新增
    computedPay: function (ele) {
      const periods = this.getPeriods(ele); // 付款期数
      const paymentPeriod = Number.parseInt(ele.paymentPeriod, 10); // 付款周期，0为全款
      const list = this.setPeriodsDate(periods, paymentPeriod, ele);
      // this.$set(ele, 'children', list);
      // ele=(list
      // return ele
      this.deviceList.push(...list);
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
  mounted() {
    this.getFuncView(null);
    this.getPageInfo();
    // this.getDeviceList();
  },
};
</script>

<style lang="scss">
.part-send-order-dialog {
  padding: 16px;

  .hide-title {
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
    color: #2c405e;
    display: none;
  }

  .part-send-order-dialog-title {
    overflow: hidden;
    text-align: center;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
  }
  .finish-time {
    text-align: right;
    font-weight: bold;
  }
  .order-list {
    margin-bottom: 24px;
    margin-top: 16px;
  }
  .date {
    font-size: 14px;
    line-height: 20px;
    color: #000;
  }
  .title-box {
    text-align: center;
    // display: flex;
    // align-items:center ;
    position: relative;
    margin-bottom: 30px;
    h3 {
      padding: 0 12px;
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      color: #000;
      line-height: 40px;
    }
    .qr-code-content {
      position: absolute;
      right: 0;
      top: 0;
      // width:38px;
    }
  }

  table {
    width: 100%;
    border: 1px solid #000;
    th {
      font-size: 12px;
      color: #000;
      font-weight: normal !important;
      text-align: left;
      padding: 0 5px;
      line-height: 30px;
      // width: calc(100% /6);
    }
    // .key{
    //   width: 16%;
    // }
    // .val{
    //   width:28%;
    // }

    .w10 {
      width: 10%;
    }
    .w20 {
      width: 20%;
    }
    .w30 {
      width: 30%;
    }
  }
}
@media print {
  *noprint::after {
    content: '' !important;
  }
  // 去掉页眉 页尾
  .header,
  .footer {
    display: none;
  }
  @page {
    // size: auto; /* auto is the initial value */
    // margin: 3mm; /* this affects the margin in the printer settings */
    size: A4 portrait;
    margin: 1.5cm 0.5cm 0mm;
    font-family: 'SimSun', '宋体' !important;
  }

  html {
    background-color: #ffffff;
    margin: 0px; /* this affects the margin on the html before sending to printer */
    font-family: 'SimSun', '宋体' !important;
  }

  body {
    // border: solid 1px blue ;
    margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
    font-family: 'SimSun', '宋体' !important;
  }
  .hide-title {
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
    color: #2c405e;
    display: block;
  }
  .part-send-order-dialog-title {
    overflow: hidden;
    text-align: center;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
  }
  .order-list {
    margin-bottom: 24px;
    margin-top: 16px;
  }
  .date {
    font-size: 14px;
    line-height: 20px;
    color: #000;
  }
  .title-box {
    text-align: center;
    // display: flex;
    // align-items:center ;
    position: relative;
    margin-bottom: 30px;

    h3 {
      padding: 0 12px;
      text-align: center;
      font-size: 22px;
      color: #000;
      line-height: 40px;
      font-weight: normal !important;
      // font-weight: bold !important;
    }
    .qr-code-content {
      position: absolute;
      right: 0;
      top: 0;
      // width:38px;
    }
  }

  table {
    width: 100%;
    border: 1px solid #000;
    th {
      font-size: 12px;
      color: #000;
      font-weight: normal !important;
      text-align: left;
      padding: 0 5px;
      line-height: 30px;
      // font-weight: bold !important;
      // width: calc(100% /6);
    }
    .w10 {
      width: 10%;
    }
    .w20 {
      width: 20%;
    }
    .w30 {
      width: 30%;
    }
  }
}
</style>
